export const NotificationType = {
    Info: "info",
    Success: "success",
    Error: "error"
};